export const SET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS =
    'SET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS';
export const RESET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS =
    'RESET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS';
